import { atom } from "recoil";
import { selector, useRecoilState } from 'recoil';
import * as _ from 'lodash'

export const loaderState = atom({
    key: "loader",
    default: false,
});

export const showNavbarState = atom({
    key: "showNavbar",
    default: true,
});

export const navbarTitleState = atom({
    key: "navbarTitle",
    default: "",
});

export const tokenState = atom( {
    key: "token",
    default: null,
})

export const bottomBarState = atom( {
    key: "bottomBar",
    default: 'profile',
})


export const showBottomBarState = atom( {
    key: "showBottomBar",
    default: true,
})

interface PlayerInterface {
    id: string,
    name: string,
    phone: string,
    email: string,
    ranking: {code: string, class: string},
    isCalibrated: boolean,
    isExpert: boolean,
    /** Tài khoản đã được xác minh — khác isCalibrated (đã thẩm định trình). */
    isVerified: boolean,
    score: Number,
    profilePicture: string,
    /** 'phone' hay 'google' — tài khoản Google không sửa được email (email do
     *  Google cung cấp, đổi đi là tự cắt đường đăng nhập của chính mình). */
    provider?: string,
    /** Mốc email được chứng minh là của chủ tài khoản (gõ đúng mã gửi qua email,
     *  hoặc đăng nhập Google bằng chính email đó). null là chưa xác thực.
     *  Khác isVerified: isVerified nói về tài khoản, không nói về email. */
    emailVerifiedAt?: string | null,
    leagues: Array<PlayerLeagueInterface>,
    roles:{isExpert:boolean, isReferee:boolean}
}

interface PlayerLeagueInterface {
    id: string,
    logo: string | null,
    banner: string,
    // /players/me trả kèm mấy trường này; khai ra để nơi dùng khỏi phải ép any.
    name?: string,
    startDate?: string,
    endDate?: string
}

export  const userState = atom<PlayerInterface>({
    key: "user",
    default: {
        id: '',
        name: '',
        phone: '',
        email: '',
        ranking: {code: "--", class: "--"},
        isCalibrated: false,
        isExpert: false,
        isVerified: false,
        score: 0,
        profilePicture: '',
        provider: 'phone',
        emailVerifiedAt: null,
        leagues:[],
        roles:{isExpert:false, isReferee:false}
    },
    dangerouslyAllowMutability: true
})

export const userLeagueSelector = selector({
    key: 'LeagueIdSelector',
    get: ({get}) => {        
        const list = get(userState)        
        if(list && list.leagues && !_.isEmpty(list.leagues) && list.leagues[0]){
            return list.leagues.map(item => item.id)
        }
        return ''
    }
});

export const showErrorNotificationState = atom<boolean>( {
    key: "errorNotification",
    default: false
})

export const errorNotificationContentState = atom<any>( {
    key: "errorNotificationContent",
    default: ""
})

export const errorNotificationTitleState = atom<any>( {
    key: "errorNotificationTitle",
    default: ""
})

export const errorNotificationButtonContentState = atom<any>( {
    key: "errorNotificationButtonContent",
    default: ""
})

/**
 * Nhịp "nạp lại trạng thái thi đấu Swiss".
 *
 * Trang giải tự nạp lại sau mọi thao tác của CHÍNH nó. Nhưng lời thách đấu đến qua
 * Firebase thì được xử lý ở SwissChallengeNotification - một component treo ở gốc
 * app, không phải trang giải. Người đang mở sẵn tab Thi đấu bấm "Xác nhận" trên hộp
 * thoại đó thì API đã chạy xong mà màn hình phía sau vẫn là trạng thái cũ, phải tự
 * kéo để làm mới.
 *
 * Điều hướng sang chính trang đang đứng KHÔNG dựng lại nó, nên không thể trông vào
 * navigate(). Ai làm đổi trạng thái thì tăng số này; trang giải nghe và nạp lại.
 */
export const swissRefreshState = atom<number>({
  key: "swissRefreshState",
  default: 0,
});
